/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Group_MinimumInputs */

const en_task_flow_group_minimum = /** @type {(inputs: Task_Flow_Group_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum ticked`)
};

const pt_br2_task_flow_group_minimum = /** @type {(inputs: Task_Flow_Group_MinimumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo marcado`)
};

/**
* | output |
* | --- |
* | "Minimum ticked" |
*
* @param {Task_Flow_Group_MinimumInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_group_minimum = /** @type {((inputs?: Task_Flow_Group_MinimumInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Group_MinimumInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_group_minimum(inputs)
	return pt_br2_task_flow_group_minimum(inputs)
});